import { render } from "./MapDormitory.vue?vue&type=template&id=41a1f5d7"
import script from "./MapDormitory.vue?vue&type=script&lang=js"
export * from "./MapDormitory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__